"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "onChangeObject", {
    enumerable: true,
    get: function() {
        return onChangeObject;
    }
});
const onChangeObject = (name, value)=>({
        name: name !== null && name !== void 0 ? name : "resources",
        target: {
            name: name !== null && name !== void 0 ? name : "resources",
            value
        }
    });

//# sourceMappingURL=OnChange.js.map